import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import { Box, SxProps, Theme } from '@mui/material';
import { FC, useState } from 'react';

interface ProductImageProps {
  alt?: string;
  src?: string;
  sx?: SxProps<Theme>;
}

export const ProductImage: FC<ProductImageProps> = ({ alt, src, sx }) => {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return (
      <Box
        sx={[
          {
            alignItems: 'center',
            bgcolor: 'action.hover',
            borderRadius: 1,
            display: 'flex',
            justifyContent: 'center',
          },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      >
        <ImageOutlinedIcon sx={{ color: 'text.disabled', fontSize: 32 }} />
      </Box>
    );
  }

  return (
    <Box
      alt={alt}
      component="img"
      onError={() => setFailed(true)}
      src={src}
      sx={sx}
    />
  );
};
